<template lang="pug">
  #lei
    navbar
    notification(
      v-if="sitewideBannerEnabled"
      :message="sitewideBannerText"
    )
    main
      router-view
    the-footer
    loading
</template>

<script>
import { mapActions, mapMutations, } from 'vuex'
import Navbar from './components/layout-components/Navbar'
import TheFooter from './components/layout-components/TheFooter'
import Loading from '@/components/layout-components/Loading'
import { EventBus, } from '@/event-bus'
import Notification from '@/components/layout-components/Notification.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    TheFooter,
    Loading,
    Notification,
  },
  data () {
    return {
      sitewideBannerEnabled: process.env.SITEWIDE_BANNER_ENABLED,
      sitewideBannerText: process.env.SITEWIDE_BANNER_TEXT,
    }
  },
  async mounted () {
    this.$cookiebot.consentBanner()

    EventBus.$on('post-data-error', this.notify)
    this.fixedSafariReadOnlyInputs()
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.changeRes(window.innerWidth)
      })
    })

    try {
      await this.getAuthUser()
    } catch (error) {
      // Some test
    }
  },
  beforeDestroy () {
    EventBus.$off('post-data-error')
  },
  methods: {
    notify (data) {
      this.$notify({
        title: data.title,
        type: 'error',
        dangerouslyUseHTMLString: true,
        message: data.message,
        duration: 0,
      })
    },
    fixedSafariReadOnlyInputs () {
      document.querySelectorAll('input[readonly]').forEach((input) => {
        input.addEventListener('focus', function () {
          this.blur()
        })
      })
    },

    ...mapActions('auth', [ 'getAuthUser', ]),
    ...mapMutations({ changeRes: 'CHANGE_WINDOW_WIDTH', }),
  },
}
</script>

<style lang="stylus">
  @import "assets/styles/variables.styl"
  #lei
    font-size $root-font-size
    color $default-color

  main
    min-height calc(100vh - 121px - 126px)
    padding 50px 0
    display flex
    flex-direction column
    align-items center

  @media screen and (max-width: $laptop)
    main
      padding 0
      min-height calc(100vh - 71px - 126px)

  @media screen and (max-width: $tablet)
    main
      min-height calc(100vh - 71px - 169px)

</style>



// WEBPACK FOOTER //
// src/App.vue